import React from 'react';
import ServicePage from '../components/ServicePage';
import { pageContent } from '../data/pageContent';
import { useLanguage } from '../context/LanguageContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

// Generic page wrapper
const PageWrapper = ({ pageKey }) => {
  const { language } = useLanguage();
  const content = pageContent[pageKey];

  if (!content) return <div>Page not found</div>;

  return (
    <>
      <Navbar />
      <ServicePage
        title={content.title[language]}
        subtitle={content.subtitle[language]}
        description={content.description[language]}
        benefits={content.benefits[language]}
        positions={content.positions[language]}
      />
      <Footer />
    </>
  );
};

// Service pages
export const TemporaryPage = () => <PageWrapper pageKey="temporary" />;
export const LeasingPage = () => <PageWrapper pageKey="leasing" />;
export const RecruitmentPage = () => <PageWrapper pageKey="recruitment" />;
export const OutsourcingPage = () => <PageWrapper pageKey="outsourcing" />;
export const ConsultingPage = () => <PageWrapper pageKey="consulting" />;

// Industry pages
export const ManufacturingPage = () => <PageWrapper pageKey="manufacturing" />;
export const LogisticsPage = () => <PageWrapper pageKey="logistics" />;
export const ITPage = () => <PageWrapper pageKey="it" />;
export const RetailPage = () => <PageWrapper pageKey="retail" />;
